import { sellerSafetyBadges, type SellerSafetyPreferences } from '@makhe/shared';

interface Props {
  preferences?: SellerSafetyPreferences;
  className?: string;
}

export function SellerSafetyBadges({ preferences, className }: Props) {
  const badges = sellerSafetyBadges(preferences);
  if (!badges.length) return null;

  return (
    <ul className={`flex flex-wrap gap-1.5 ${className ?? ''}`}>
      {badges.map((badge) => (
        <li
          key={badge}
          className="rounded-full bg-makhe-line/40 px-2.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-makhe-muted"
        >
          {badge}
        </li>
      ))}
    </ul>
  );
}
